import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { safeLocalStorageGet } from "@/utils/safe-local-storage";

// Import all Polish translations
import common from "./pl/common.json";
import auth from "./pl/auth.json";
import onboarding from "./pl/onboarding.json";
import upload from "./pl/upload.json";
import history from "./pl/history.json";
import results from "./pl/results.json";
import kb from "./pl/kb.json";
import settings from "./pl/settings.json";
import feedback from "./pl/feedback.json";
import billing from "./pl/billing.json";
import errors from "./pl/errors.json";
import validation from "./pl/validation.json";
import assessments from "./pl/assessments.json";
import monitoring from "./pl/monitoring.json";
import internal from "./pl/internal.json";
import dashboard from "./pl/dashboard.json";

// Import all English translations
import enCommon from "./en/common.json";
import enAuth from "./en/auth.json";
import enOnboarding from "./en/onboarding.json";
import enUpload from "./en/upload.json";
import enHistory from "./en/history.json";
import enResults from "./en/results.json";
import enKb from "./en/kb.json";
import enSettings from "./en/settings.json";
import enFeedback from "./en/feedback.json";
import enBilling from "./en/billing.json";
import enErrors from "./en/errors.json";
import enValidation from "./en/validation.json";
import enAssessments from "./en/assessments.json";
import enMonitoring from "./en/monitoring.json";
import enInternal from "./en/internal.json";
import enDashboard from "./en/dashboard.json";

const storedAppLanguage = safeLocalStorageGet("vardic_app_language");
const initialLanguage =
  storedAppLanguage === "en" || storedAppLanguage === "pl"
    ? storedAppLanguage
    : "pl";

void i18n
  .use(initReactI18next)
  .init({
    lng: initialLanguage,
    fallbackLng: "pl",
    resources: {
      pl: {
        common,
        auth,
        onboarding,
        upload,
        history,
        results,
        kb,
        settings,
        feedback,
        billing,
        errors,
        validation,
        assessments,
        monitoring,
        internal,
        dashboard,
      },
      en: {
        common: enCommon,
        auth: enAuth,
        onboarding: enOnboarding,
        upload: enUpload,
        history: enHistory,
        results: enResults,
        kb: enKb,
        settings: enSettings,
        feedback: enFeedback,
        billing: enBilling,
        errors: enErrors,
        validation: enValidation,
        assessments: enAssessments,
        monitoring: enMonitoring,
        internal: enInternal,
        dashboard: enDashboard,
      },
    },
    interpolation: {
      escapeValue: false, // React already escapes
    },
    // Show warnings for missing keys in development
    saveMissing: import.meta.env.DEV,
    missingKeyHandler: (_lng, ns, key) => {
      if (import.meta.env.DEV) {
        console.warn(`Missing translation: [${ns}] ${key}`);
      }
    },
  });

export default i18n;
